import { render, staticRenderFns } from "./RegulatoryLimitReport.vue?vue&type=template&id=1cca0170&scoped=true&"
import script from "./RegulatoryLimitReport.vue?vue&type=script&lang=js&"
export * from "./RegulatoryLimitReport.vue?vue&type=script&lang=js&"
import style0 from "./RegulatoryLimitReport.vue?vue&type=style&index=0&id=1cca0170&lang=scss&scoped=true&"
import style1 from "./RegulatoryLimitReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cca0170",
  null
  
)

export default component.exports